import React, { useState } from 'react';
import './Footer.scss';

const currentYear = new Date().getFullYear();

export default function Footer() {
    const [siteConfig, setSiteConfig] = useState(JSON.parse(localStorage.getItem('siteConfig') || ""))
    return (
        <div className="footer">
            <span className="footer-left">
                {siteConfig.activeSite === 'CAQ' && <>
                    <p className="logo-text">construct
                        <span className="logo-text-white">a</span>quote<span className="logo-text-white">.com</span></p>
                    <p>Copyright &copy; {currentYear} Moorhouse Group Ltd. All Rights Reserved.</p>
                </>}
                {siteConfig.activeSite === 'BW' &&
                    <>
                    <img className="footer-logo" src={`../../../theme/logos/${siteConfig.activeSite}_logo.png`} alt="logo" />
                    </>}
                
            </span>
            <span className="footer-right">
                <p>constructaquote.com, black and white, cover 4 landlords and Xbroker are trading names of Moorhouse Group Limited, Registered in England and Wales, Company number: 3825233, Data Protection Number: Z481498X, Registered address: Barclay House, 2-3 Sir Alfred Owen Way, Caerphilly, CF83 3HU.</p>
                <p>Authorised and regulated by the Financial Conduct Authority under Firm Reference Number 308035. This can be checked on the Financial Services Register at <a href="https://www.fca.org.uk/register" rel="noreferrer" target="_blank">www.fca.org.uk/register.</a></p>
                {siteConfig.activeSite === 'BW' &&
                    <p>Copyright &copy; {currentYear} Moorhouse Group Ltd. All Rights Reserved.</p>
                }
            </span>
        </div>
    );
}